import { useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { DataTable } from "../components/DataTable";
import { toast } from "sonner";

const ACTION_LABELS = {
  login: "Connexion", "user.create": "Création utilisateur", "user.update": "Modification utilisateur", "user.delete": "Suppression utilisateur",
  "product.create": "Création produit", "product.update": "Modification produit/prix", "product.delete": "Suppression produit", "product.archive": "Archivage produit",
  "sale.create": "Vente", "sale.settle": "Règlement vente", "sale.cancel": "Annulation vente",
  "purchase.create": "Achat", "purchase.receive": "Réception achat", "purchase.settle": "Règlement fournisseur",
  "stock.adjust": "Ajustement stock", "stock.transfer": "Transfert stock",
  "expense.create": "Dépense", "expense.delete": "Suppression dépense",
  "cash.transfer": "Transfert caisse", "cash.closing": "Clôture caisse",
  "document.create": "Création document", "document.convert": "Conversion en vente", "document.delete": "Suppression document",
  "inventory.validate": "Validation inventaire", "settings.update": "Modification paramètres",
  "report.export": "Export rapport", "customer.delete": "Suppression client", "supplier.delete": "Suppression fournisseur",
  "warehouse.create": "Création dépôt", "unauthorized_attempt": "TENTATIVE NON AUTORISÉE", "unauthorized_price_change": "TENTATIVE MODIF PRIX",
  "admin.tenant_update": "Admin: mise à jour quincaillerie",
};

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [pg, setPg] = useState({ total: 0, pages: 1 });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const load = (p = page, s = search) =>
    api.get("/audit", { params: { page: p, limit: 50, search: s } })
      .then((r) => { setRows(r.data.items); setPg({ total: r.data.total, pages: r.data.pages }); })
      .catch((e) => toast.error(errMsg(e)));
  useEffect(() => {
    const t = setTimeout(() => load(1, search), search ? 300 : 0);
    return () => clearTimeout(t);
  }, [search]);
  useEffect(() => { load(page, search); }, [page]);

  const columns = [
    { key: "created_at", label: "Date/Heure", render: (a) => <span className="font-money text-xs">{fmtDateTime(a.created_at)}</span> },
    { key: "user_name", label: "Utilisateur", render: (a) => (
      <div><div className="font-semibold">{a.user_name}</div><div className="text-xs text-muted-foreground">{a.user_email}</div></div>) },
    { key: "action", label: "Action", render: (a) => (
      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${a.action.startsWith("unauthorized") ? "bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300" : "bg-secondary text-secondary-foreground"}`}>
        {ACTION_LABELS[a.action] || a.action}</span>) },
    { key: "details", label: "Détails", render: (a) => <span className="text-xs text-muted-foreground font-mono">{JSON.stringify(a.details)}</span> },
  ];

  return (
    <div className="space-y-4" data-testid="audit-page">
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">Journal d'Audit</h1>
      <p className="text-sm text-muted-foreground">Journal non modifiable des opérations sensibles de votre quincaillerie.</p>
      <DataTable testid="audit-table" columns={columns} rows={rows} serverSide
        serverTotal={pg.total} serverPage={page} serverPages={pg.pages}
        onPageChange={setPage} onSearch={(v) => { setSearch(v); setPage(1); }} />
    </div>
  );
}
